import { render, staticRenderFns } from "./RuischoolscUser.vue?vue&type=template&id=30aeaa16&scoped=true&"
import script from "./RuischoolscUser.vue?vue&type=script&lang=js&"
export * from "./RuischoolscUser.vue?vue&type=script&lang=js&"
import style0 from "./RuischoolscUser.vue?vue&type=style&index=0&id=30aeaa16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aeaa16",
  null
  
)

export default component.exports